import { schema } from "normalizr";
import { titlesTypes } from "../types";
import Resource from "./resource";

export const titlesSchema = new schema.Entity("titles");

export default new Resource("/titles", titlesTypes, titlesSchema);
